module.exports = __webpack_public_path__ + "img/business_pay_04.png";